import React, { Component, PropTypes } from 'react';

import { Button } from 'muicss/react';
import { notificationActions } from 'constants/notifications';

class Notification extends Component {
  handleResolve = () => {
    const { handleClickResolve, notification } = this.props;
    handleClickResolve(notification);
  };

  render() {
    const {
      handleCloseNotification,
      handleVisitToGBP,
      notification: { id, subheading, heading, body, action },
    } = this.props;

    return (
      <div className={ 'notification-item flex justify-between' }>
        <div className={ 'flex flex-col' }>
          <span className={ 'notification-sub-info' }>{ subheading }</span>
          <span className={ 'notification-title' }>{ heading }</span>
          <span className={ 'notification-description' }>{ body }</span>
        </div>
        <div className={ 'flex flex-end items-center' }>
          {
            (action === notificationActions.RESOLVE
              || action === notificationActions.RESOLVE_CLOSE) ? (
                <Button
                  className='mui-btn--secondary text-primary-type'
                  type='button'
                  onClick={ this.handleResolve }
                >
                  Replace
                </Button>
            ) : null
          }
          {
            (action === notificationActions.CLOSE
              || action === notificationActions.RESOLVE_CLOSE) ? (
                <Button
                  className='mui-btn--secondary text-primary-type'
                  type='button'
                  onClick={ () => handleCloseNotification(id) }
                >
                  Close
                </Button>
              ) : null
          }
          {
            (action === notificationActions.DIRECT_TO_LOCATION) ? (
              <Button
                className='mui-btn--secondary text-primary-type'
                type='button'
                onClick={() => { handleVisitToGBP(id) }}
              >
                Visit Google Location
              </Button>
            ) : null
          }
        </div>
      </div>
    );
  }
}

Notification.propTypes = {
  notification: PropTypes.object,
  handleClickResolve: PropTypes.func,
  handleCloseNotification: PropTypes.func,
  handleVisitToGBP: PropTypes.func,
};

export default Notification;
